// TeamsIJoined.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";
import Tooltip from '../../components/utils/Tooltip';

const TeamsIJoined = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();

  const navigate = useNavigate();
  const userId = authState.user._id;
  const userCode = authState.user.think5whyscode;
  const [joinedTeams, setJoinedTeams] = useState([]);
  const [hasJoinedTeamStatusMsg, setHasJoinedTeamStatusMsg] = useState(false);
  const [hasJoinedTeamStatus, setHasJoinedTeamStatus] = useState('');
  const [selectedTeamId, setSelectedTeamId] = useState([]);
  const [selectedViewMemberTeamId, setSelectedViewMemberTeamId] = useState(false);
  const [selectedAddMemberTeamId, setSelectedAddMemberTeamId] = useState(false);

  const [hasNewMemberCodeClicked, setHasNewMemberCodeClicked] = useState(false);
  // const [newMemberCode, setNewMemberCode] = useState('');

  const [newMemberCodeStatus, setNewMemberCodeStatus] = useState(false);
  const [newMemberCodeStatusMsg, setNewMemberCodeStatusMsg] = useState('');
  const [newMemberCode, setNewMemberCode] = useState('');
  const [newMemberId, setNewMemberId] = useState('');
  const [newMemberName, setNewMemberName] = useState('');
  const [newMemberEmail, setNewMemberEmail] = useState('');
  const [newMemberCodeMsg, setNewMemberCodeMsg] = useState('');
  const [verifyNewMemberCodeButtonClicked, setVerifyNewMemberCodeButtonClicked] = useState(false);
  const [error, setError] = useState('');
  const [addNewButtonClickedStatus, setAddNewButtonClickedStatus] = useState(false);
  const [addNewMemberRecordStatus, setAddNewMemberRecordStatus] = useState(false);
  const [addNewMemberRecordStatusMsg, setAddNewMemberRecordStatusMsg] = useState('');

  useEffect(() => {
    fetchMyJoinedTeamList(); 
  }, []);

  const fetchMyJoinedTeamList = useCallback(() => {
    // console.log("fetchMyJoinedTeamList for API call ", authState.user._id);
    const config = {
        url: "/myteammembers/myjoinedlist",
        method: "post",
        headers: { Authorization: authState.token },
        data: { memberId: authState.user._id }
    };
  
    fetchData(config)
        .then(response => {
          // console.log("API Response: ", response); 
            if (response && response.status) {
                // console.log("team joined list found ", response);
                setHasJoinedTeamStatus(true);
                setJoinedTeams(response.teams);
                setHasJoinedTeamStatusMsg("Teams you joined found. 😊");
            } else {
                // console.log("Teams Code Not found");
                setHasJoinedTeamStatusMsg(`Teams you have not joined yet! 😔`);
            }
        })
        .catch(error => {
            // console.log("Teams Not found!", error);
            setHasJoinedTeamStatusMsg("Error in getting data");
        });
  }, [fetchData, authState.token, setJoinedTeams]);
  
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
  }, [authState.isLoggedIn, fetchMyJoinedTeamList]);

  const handleTeamView = (_id) => {
    setSelectedTeamId(prevId => (prevId === _id ? null : _id));
  };

  const formatDateTime = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const teamTypeNames = {
    PRJ: "Project",
    DEP: "Departmental",
    BRA: "Branch",
    ZON: "Zonal",
    REG: "Regional",
    COM: "Company Wide",
    INS: "Institutional",
    ADM: "Administration",
    MIN: "Ministry",
    PRO: "Professional",
    ACA: "Academic",
    FRI: "Friends",
    FAM: "Family",
    MAN: "Management",
    CAM: "Campaign",
    INV: "Investigation",
    FAC: "Fact Finding",
    FUN: "Fun",
    WOR: "Work"
  };

  return (
    <MainLayout>
      <div className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - Team / Groups I Have Joined</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white'>
        <div className="mt-4">
          {joinedTeams.length === 0 ? (
            <div className='flex justify-center'>
              <p className='text-orange-600'>You Have Not Joined Any Team / Group Yet</p>
            </div>
          ) : (
            joinedTeams.map((team, index) => (
              <div key={team._id} className='bg-gray-700 my-1 p-4 text-gray-600 rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium text-yellow-200'>
                    {index + 1}. {team.teamTitle}
                  </span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleTeamView(team._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
               </div>
                {selectedTeamId === team._id && (
                  <div className='bg-gray-600 text-black'>
                    <p><strong>Team Title:</strong> {team.teamTitle}</p>
                    <p><strong>Team Created By:</strong> {team.creatorName}</p>
                    <p><strong>Team/Group Type:</strong> {team.teamType}</p>
                    <p><strong>Created Date:</strong> {formatDateTime(team.dateCreated)}</p>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </MainLayout>
  );  
};

export default TeamsIJoined;


